import { useNavigate } from 'react-router-dom';
import { Tabs, Tab, Paper} from '@mui/material';


interface AdminTabsProps {
  currentPath: string;
}

export default function AdminTabs({ currentPath }: AdminTabsProps) {
  const navigate = useNavigate();
  const tabs = [
    { label: 'Hotels', path: '/admin' },
    { label: 'Conferences', path: '/admin/conferences' },
    { label: 'Orders', path: '/admin/orders' },
    { label: 'Messages', path: '/admin/messages' },
    { label: 'Users', path: '/admin/users' },
    { label: 'Reports', path: '/admin/reports'}
  ];

  const getCurrentTabIndex = () => {
    const index = tabs.findIndex(tab => tab.path === currentPath);
    return index >= 0 ? index : 0;
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const targetPath = tabs[newValue]?.path;
    if (targetPath) {
      navigate(targetPath);
    }
  };

  return (
    <Paper sx={{ mb: 3 }}>
      <Tabs 
        value={getCurrentTabIndex()} 
        onChange={handleTabChange}
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        {tabs.map((tab, index) => {          
          return (
            <Tab key={index} label={tab.label} href={tab.path} />
          );
        })}
      </Tabs>
    </Paper>
  );
}